module.exports = __webpack_public_path__ + "static/img/about_us_bg.76b812e3.jpg";